<template>
  <li
    :class="[
      ns.be('dropdown', 'item'),
      ns.is('disabled', itemDisabled),
      {
        selected: select?.itemAllSelected,
        hover,
      },
    ]"
    @mouseenter="hoverItem"
    @click.stop="selectOptionClick"
  >
    <template v-if="isMultiple && componentName === currentComponentName">
      <jd-checkbox
        :disabled="itemDisabled"
        :model-value="select?.itemAllSelected"
        :indeterminate="select?.itemAllIndeterminate"
        @click.stop="selectOptionClick"
      >
        <span>{{ text || t('el.select.all') || 'All' }}</span>
      </jd-checkbox>
    </template>
    <template v-else>
      <slot>
        <span>{{ text || t('el.select.all') || 'All' }}</span>
      </slot>
    </template>
  </li>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  getCurrentInstance,
  inject,
  onBeforeUnmount,
  reactive,
  toRefs,
} from 'vue'
import JdCheckbox from '@jdesign-vue/components/checkbox'
import { useLocale, useNamespace } from '@jdesign-vue/hooks'
import { useOption } from './useOption'
import { selectKey } from './token'
import type { SelectOptionProxy } from './token'
const currentComponentName = 'JdOptionAll'

export default defineComponent({
  name: currentComponentName,
  componentName: currentComponentName,
  components: {
    JdCheckbox,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
  },
  setup(props) {
    const { t } = useLocale()
    const parentSelect = inject(selectKey)!
    const isMultiple = computed(() => parentSelect.props.multiple)
    const componentName = getCurrentInstance()?.type?.name

    const ns = useNamespace('select')
    const states = reactive({
      index: -1,
      hitState: false,
      hover: false,
    })

    const { isDisabled, select, hoverItem } = useOption(props, states)

    const itemDisabled = computed(
      () => isDisabled.value || (select?.props.multipleLimit as any) > 0
    )

    const { hover } = toRefs(states)

    const vm = getCurrentInstance()?.proxy as unknown as SelectOptionProxy
    const key = (vm as unknown as SelectOptionProxy).value
    select?.onOptionCreate(vm as unknown as SelectOptionProxy)

    onBeforeUnmount(() => {
      select?.onOptionDestroy(key, vm)
    })

    function selectOptionClick(e?: PointerEvent) {
      if (e && (e.target as any)?.tagName === 'INPUT') {
        return
      }
      if (itemDisabled.value !== true) {
        select?.handleOptionSelectAll()
      }
    }

    return {
      t,
      ns,
      isDisabled,
      select,
      hoverItem,
      hover,
      selectOptionClick,
      states,
      isMultiple,
      componentName,
      currentComponentName,
      itemDisabled,
    }
  },
})
</script>
